import { render } from "./RadioButtons.vue?vue&type=template&id=6430a449&scoped=true"
import script from "./RadioButtons.vue?vue&type=script&lang=js"
export * from "./RadioButtons.vue?vue&type=script&lang=js"

import "./RadioButtons.vue?vue&type=style&index=0&id=6430a449&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6430a449"]])

export default __exports__